import { render, staticRenderFns } from "./SummaryData.vue?vue&type=template&id=50ef2f2e&"
import script from "./SummaryData.vue?vue&type=script&lang=js&"
export * from "./SummaryData.vue?vue&type=script&lang=js&"
import style0 from "./SummaryData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports